module.exports = __webpack_public_path__ + "img/plus-icon.f26b2c31.svg";